import { render, staticRenderFns } from "./header-modular.vue?vue&type=template&id=ee7d166c&scoped=true&"
import script from "./header-modular.vue?vue&type=script&lang=js&"
export * from "./header-modular.vue?vue&type=script&lang=js&"
import style0 from "./header-modular.vue?vue&type=style&index=0&id=ee7d166c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7d166c",
  null
  
)

export default component.exports